import { useEffect } from 'react';

function useOutsideOfElement({ element, hook, value }) {
  useEffect(() => {
    // if outside of dropdown element is clicked, hide dropdown
    function handleClickOutside() {
      if (element && !element.current.contains(event.target)) {
        hook(value);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });
}

export default useOutsideOfElement;
